import styled from "styled-components";

// layout
export const ProfessionalsListBackgroundPage = styled.div`
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, #f8f9ff 0%, #ffffff 50%);
    min-height: 100vh;
`

export const ProfessionalsListInternalPage = styled.div`
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    @media (min-width: 768px) {
        padding: 0 40px;
    }
`

// heading
export const ProfessionalsListHeading = styled.div`
    color: #2d3748;
    font-family: Outfit, sans-serif;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: -0.5px;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    padding: 0 0 32px 0;
    @media (min-width: 768px) { 
        font-size: 32px;
        font-weight: 700;
        padding: 0 0 48px 0;
    }
`

// main content layout

export const ProfessionalsMainContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 32px;
    @media (min-width: 1000px) {
        flex-direction: row;
        gap: 48px;
    }
`

// category selection

export const ProfessionalsCategoryContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow: auto;
    gap: 12px;
    flex-shrink: 0;
    padding-bottom: 8px;
    ::-webkit-scrollbar {
        height: 6px;
    }
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background: #cbd5e0;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb:hover {
        background: #a0aec0;
    }
  
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: thin;  /* Firefox */
    scrollbar-color: #cbd5e0 #f1f1f1;
    @media (min-width: 1000px) {
        flex-direction: column;
        width: 280px;
        overflow: visible;
        gap: 8px;
    }
`

export const ProfessionalCategoryButton = styled.button`
    color: ${props => props?.active ? '#ffffff' : '#4a5568'};
    font-family: Outfit, sans-serif;
    flex-shrink: 0;
    font-size: 15px;
    font-style: normal;
    font-weight: ${props => props?.active ? '600' : '500'};
    line-height: 1.5;
    letter-spacing: 0.1px;
    border-radius: 12px;
    background: ${props => props?.active 
        ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
        : '#ffffff'};
    padding: 12px 24px;
    border: ${props => props?.active ? 'none' : '2px solid #e2e8f0'};
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: ${props => props?.active 
        ? '0 4px 12px rgba(102, 126, 234, 0.3)' 
        : '0 2px 4px rgba(0, 0, 0, 0.05)'};
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: ${props => props?.active 
            ? '0 6px 16px rgba(102, 126, 234, 0.4)' 
            : '0 4px 8px rgba(0, 0, 0, 0.1)'};
        background: ${props => props?.active 
            ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
            : '#f7fafc'};
    }
    
    &:active {
        transform: translateY(0);
    }
    
    @media(min-width: 768px){
        border: ${props => props?.active ? 'none' : '2px solid #e2e8f0'};
        padding: 14px 20px;
        font-size: 16px;
    }
    
    @media (min-width: 1000px) {
        width: 100%;
        text-align: left;
        padding: 16px 24px;
    }
`

// professional selection

export const ProfessionalsItemsListContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: flex-start;
    @media (min-width: 768px) {
        gap: 32px;
    }
`

export const ProfessionalsItemContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 24px;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    min-height: 400px;
    height: 100%;
    
    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(102, 126, 234, 0.15);
        border-color: #cbd5e0;
    }
    
    @media (min-width: 568px) {
        flex-direction: row;
        gap: 32px;
        padding: 28px;
        align-items: flex-start;
        min-height: 320px;
    }
    
    @media (min-width: 768px) {
        padding: 32px;
        gap: 40px;
        border-radius: 24px;
        min-height: 360px;
    }
    
    @media (min-width: 1024px) {
        min-height: 380px;
    }
`

export const ProfessionalsItemPicture = styled.div`
    width: 200px;
    height: 240px;
    flex-shrink: 0;
    border-radius: 20px;
    background: url(${props => props?.image});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    overflow: hidden;
    cursor: ${props => props?.clickable ? 'pointer' : 'default'};
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
        transform: ${props => props?.clickable ? 'scale(1.02)' : 'none'};
        box-shadow: ${props => props?.clickable 
            ? '0 8px 24px rgba(102, 126, 234, 0.25)' 
            : '0 4px 16px rgba(0, 0, 0, 0.12)'};
    }
    
    @media (min-width: 568px) {
        width: 220px;
        height: 260px;
    }
    
    @media (min-width: 768px) {
        width: 280px;
        height: 320px;
        border-radius: 24px;
    }
`

export const ProfessionalItemHeading = styled.div`
    color: ${props => props?.small ? '#718096' : '#2d3748'};
    font-family: Outfit, sans-serif;
    font-style: normal;
    line-height: 1.4;
    cursor: default;
    font-size: ${props => props?.small ? '16px' : '22px'};
    font-weight: ${props => props?.small ? '500' : '700'};
    letter-spacing: -0.3px;
    margin-bottom: ${props => props?.small ? '8px' : '12px'};
    text-align: ${props => props?.small ? 'left' : 'center'};
    @media (min-width: 568px) {
        text-align: left;
    }
    @media(min-width: 768px){
        font-size: ${props => props?.small ? '18px' : '28px'};
        font-weight: ${props => props?.small ? '600' : '700'};
        letter-spacing: -0.5px;
        margin-bottom: ${props => props?.small ? '12px' : '16px'};
    }
`

export const ProfessionalItemDescription = styled.div`
    color: ${props => props?.bold ? '#4a5568' : '#718096'};
    font-family: Outfit, sans-serif;
    cursor: default;
    font-style: normal;
    line-height: 1.6;
    font-size: 15px;
    font-weight: ${props => props?.bold ? '500' : '400'};
    letter-spacing: 0.1px;
    margin-bottom: ${props => props?.bold ? '8px' : '12px'};
    text-align: center;
    @media (min-width: 568px){
        text-align: left;
    }
    @media(min-width: 768px){
        font-size: 16px;
        letter-spacing: 0.12px;
        margin-bottom: ${props => props?.bold ? '12px' : '16px'};
    }
`

export const ProfessionalEventItem = styled.div`
    border: 2px solid #e2e8f0;
    padding: 10px 16px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 14px;
    color: #2d3748;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    font-family: Outfit, sans-serif;
    
    &:hover {
        border-color: #667eea;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #ffffff;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    @media (min-width: 768px) {
        padding: 12px 20px;
        font-size: 15px;
        border-radius: 12px;
    }
`

export const ProfessionalSeparator = styled.div`
    width: 100%;
    margin: 20px 0;
    background: linear-gradient(to right, transparent, #e2e8f0, transparent);
    height: 1px;
    @media (min-width: 568px) {
        width: 80%;
        margin: 24px 0;
    }
`

export const ProfessionalNextAvailableBox = styled.div`
    display: flex;
    flex-direction: column;
    cursor: default;
    justify-content: center;
    align-items: center;
    border-radius: 21px;
    background: #E3EBFF;
    flex-shrink: 0;
    padding: 5px 0;
    width: 200px;
    margin: 20px auto 0 auto;
    @media (min-width: 568px) {
        margin: 20px 0 0 0;
        width: 250px;
        padding: 15px 0;
    }
`

export const ProfessionalNextAvailableText = styled.div`
    color: ${props => props?.heading ? '#567EE3' : '#152A5F'};
    font-family: Outfit;
    font-size: ${props => props?.heading ? '17px' : '15px'};
    font-style: normal;
    font-weight: ${props => props?.heading ? '600' : '400'};
    line-height: normal;
    letter-spacing: 0.14px;
    @media (min-width: 768px) {
        
    }
`

export const BookNowStrip = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    font-family: Outfit, sans-serif;
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;
    padding: 10px 0;
    font-size: 14px;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.5px;
    text-transform: uppercase;
    transition: all 0.3s ease;
    
    @media (min-width: 768px){
        padding: 14px 0;
        font-size: 16px;
    }
`